let Legend = function (props) {
  let {
    items,
    flow = "across",
    onCheck
  } = props;

  return (
    <ul className="mc-legend" data-flow={flow}>
      {items.map(function (item, i) {
        let bullet = item.bullet || Legend.SQUARE;

        return (
          <li
            key={i}
            role={onCheck ? "checkbox" : null}
            aria-checked={onCheck ? item.checked : null}
            onClick={onCheck ? () => onCheck(item.value, !item.checked) : null}>
              {bullet(item)}
              <span>{item.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

Legend.SQUARE = function (item) {
  return (
    <svg width="10" height="10">
      <rect width="10" height="10" fill={item.color}/>
    </svg>
  );
};

Legend.CIRCLE = function (item) {
  return (
    <svg width="10" height="10">
      <circle cx="5" cy="5" r="5" fill={item.color}/>
    </svg>
  );
};

Legend.DOT = function (item) {
  return (
    <svg width="10" height="10">
      <circle cx="5" cy="5" r="3" fill={item.color}/>
    </svg>
  );
};

Legend.DIAMOND = function (item) {
  return (
    <svg width="10" height="10">
      <path d="M5,0 L10,5 L5,10 L0,5Z" fill={item.color}/>
    </svg>
  );
};

Legend.TRIANGLE = function (item) {
  return (
    <svg width="10" height="10">
      <path d="M0,10 L5,1 L10,10Z" fill={item.color}/>
    </svg>
  );
};

Legend.LINE = function (item) {
  return (
    <svg width="20" height="10">
      <path d="M0,5 L20,5Z" stroke={item.color} fill="none" strokeWidth="2"/>
    </svg>
  );
};

Legend.DASHED_LINE = function (item) {
  return (
    <svg width="20" height="10">
      <path d="M0,5 L20,5Z" stroke={item.color} fill="none" strokeWidth="2" strokeDasharray="4 3"/>
    </svg>
  );
};

Legend.CURVE = function (item) {
  return (
    <svg width="20" height="10">
      <path d="M3,7 C5,2 9,2 11,5 C12,6 15,9 19,2" stroke={item.color} fill="none" strokeWidth="2"/>
    </svg>
  );
};

Legend.SPLINE = function (item) {
  return (
    <svg width="20" height="10">
      <path d="M0,5 L20,5Z" stroke={item.color} fill="none" strokeWidth="2"/>
      <circle cx="10" cy="5" r="3" fill={item.color}/>
    </svg>
  );
};

module.exports = Legend;